module.exports = __webpack_public_path__ + "static/media/arrow-right.79fe1574.svg";